module.exports = __webpack_public_path__ + "img/h5_game_detail_lucky5_regular.58e16d9d.jpg";